export default __webpack_public_path__ + "static/dook-0f3187676d8d92da3642d5abc48ede9a.png";